import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { apiColletions } from "src/app/core/constants/api_collection";
import { Helper } from "src/app/core/helpers/helper";

@Injectable({
  providedIn: "root"
})
export class AdminService {
  constructor(private apiService: ApiService, private helper: Helper) {}

  /**
   * Fetches the dispatcher role assigned to the logged-in account.
   *
   * Returns the role's `urls` — one entry per granted page, each carrying the six-bit permission string
   * the sidebar filter and `helper.hasPermission` read.
   *
   * Two unwraps, not one: `apiService.get` wraps the HTTP body as `{ data: body }`, and the body is
   * itself `{ data: { dispatcherRole } }`.
   */
  getDispatcherRoleDetails(roleId: string): Observable<any> {
    return new Observable<any>((observer) => {
      this.apiService.get({ url: `${apiColletions.dispatcherRole}/${roleId}`, parameters: { isShowSuccessToast: false } }).subscribe({
        next: (response) => {
          observer.next(response?.data?.data ?? false);
          observer.complete();
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getDetails(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.post({ url: apiColletions.getEntityDetail, parameters: parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            this.helper.adminSettings = response.data.data.setting;
            this.helper.MapBoxAccessToken = this.helper.adminSettings.mapKey;

            this.helper.isOtpLoginEnabledForEmail = this.helper.adminSettings?.entitySetting.loginBy.email.includes(this.helper.LoginBy.OTP);
            this.helper.isOtpLoginEnabledForPhone = this.helper.adminSettings?.entitySetting.loginBy.phone.includes(this.helper.LoginBy.OTP);
            this.helper.isPasswordLoginEnabledForPhone = this.helper.adminSettings?.entitySetting.loginBy.phone.includes(this.helper.LoginBy.PASSWORD);
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
